import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import PendingForReview from "./PendingForReview";
import AvgTatIcon from "../../../asset/images/checkerOffMarket/AvgTat.svg";
import InQueueIcon from "../../../asset/images/checkerOffMarket/InQueue.svg";
import ApprovedTodayIcon from "../../../asset/images/checkerOffMarket/ApprovedToday.svg";
import RejectedTodayIcon from "../../../asset/images/checkerOffMarket/RejectedToday.svg";
import { Off_Market } from "../../../Configuration/API_URL";
import { AESEncryption, alphaNumericUppercase, alphaNumericUppercasePaste, ApiResDecrypt, noDataFound, toTitleCase } from "../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import { useDebounce } from "../../../Components/useDebounce";
import moment from "moment";
import Loader from "../../../Components/Common/Loader";
import editIcon from "../../../asset/images/edit-withfile.svg";
import uparrowSort from "../../../asset/images/up-arrow-acc.svg";
import downarrowSort from "../../../asset/images/down-arrow-acc.svg";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Modal } from "react-bootstrap";
import infoIcon from "../../../asset/images/info-circle.svg";
import filter from "../../../asset/images/preference-horizontal.svg";
import CustomTradeDate from "../../../CommonMethhods/CustomDate";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function CheckerMain() {
  const storeToken = localStorage.getItem("ssoToken");
  const [serviceRequests, setServiceRequests] = useState([]);
  const [selectedSRId, setSelectedSRId] = useState(null);
  const [search, setSearch] = useState("");
  const [cardData, setCardData] = useState("");
  const [filterModal, setFilterModal] = useState(false);
  const [statusFilter, setStatusFilter] = useState("all");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loader, setLoader] = useState(false);
  const [count, setCount] = useState();
  const [selectedSR, setSelectedSR] = useState(null);
  const [btnLoader, setBtnLoader] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    field: "",
    direction: "asc",
  });

  useEffect(() => {
  const mode = localStorage.getItem("darkmode");

  if (mode === "true") {
    document.body.classList.add("darkmode");
  } else {
    document.body.classList.remove("darkmode");
  }
}, []);
  const reviewSectionRef = useRef(null);

  const handleSort = (field, type) => {
    setSortConfig((prev) => ({
      field,
      type,
      direction:
        prev.field === field && prev.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  const debouncedValue = useDebounce(search, 1000);

  useEffect(() => {
  setPage(1);
}, [debouncedValue]);


  const filtered = serviceRequests.filter(
    (sr) =>
      sr?.clientName?.toLowerCase().includes(search.toLowerCase()) ||
      sr?.clientCode?.toLowerCase().includes(search.toLowerCase()) ||
      sr?.srId?.toLowerCase().includes(search.toLowerCase())
      
  );


  const getCardSummary = async () => {
    // setLoader(true);

    try {
      const getDetails = await axiosInstance.get(
        Off_Market.checkerCardStatus,

      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        setCardData(res?.data[0])

      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);

    } finally {
      // setLoader(false);
    }
  };

  useEffect(() => {
    getCardSummary();
  }, []);

  const getPayload = (type = "grid", searchKey = search, startDate = fromDate,
  endDate = toDate) => {

    const payload = {
      status: statusFilter === "all" ? "" : statusFilter,
      search: searchKey,
      // start_date: fromDate ? moment(fromDate).format("DD-MM-YYYY") : "",
      // end_date: toDate ? moment(toDate).format("DD-MM-YYYY") : "",
      start_date: startDate ? moment(startDate, "DD-MM-YYYY").format("DD-MM-YYYY") : "",
      end_date: endDate ? moment(endDate, "DD-MM-YYYY").format("DD-MM-YYYY") : "",
      file_type: type,
    };


    if (type === "grid") {
      payload.page = page;
      payload.limit = limit;
    }

    return payload;
  };

  const getSrRequestData = async (type = "grid", searchKey, startDate, endDate) => {
    setLoader(true);

    try {
      const payload = getPayload(type, searchKey, startDate, endDate);
      const encPayload = AESEncryption(payload)

      const getDetails = await axiosInstance.post(
        Off_Market.serviceRequest,
        `"${encPayload}"`,

      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.status === 0) {
        if (type === "grid") {
          const mappedData = res?.data?.data?.map((item) => ({
            id: item?.id,
            clientName: item?.ClientName,
            clientCode: item?.ClientCode,
            srId: item?.sr_id || "-",
            isin: item?.ISIN,
            records: item?.records,
            submissionDate: item?.submission_date,
            status: item?.Status,
            rejectionRemarks: item?.RejectionRemark
          }));

          setServiceRequests(mappedData);
          setCount(res?.data?.total)
        } else {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }

      } else {
        if (type === "grid") {
          setServiceRequests([]);
        }
        else {
          toast.error(res?.message);
        }
      }
    } catch (error) {
      console.log(error);

    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getSrRequestData("grid", debouncedValue, fromDate, toDate);
  }, [page, limit, statusFilter, debouncedValue]);

  const handleViewButton = (sr) => {
    setSelectedSRId(sr);
    viewClientDetails(sr)
  }

  const viewClientDetails = async (sr) => {
    setBtnLoader(sr?.id)
    const payload = {
      clientCode: sr?.clientCode
    }

    const encPayload = AESEncryption(payload)
    try {

      const getDetails = await axiosInstance.post(
        Off_Market.getClientDetails,
        `"${encPayload}"`,

      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.status === 0) {
        setSelectedSR({
          ...res?.data,
          id: sr.id,
          status: sr?.status,
          rejectionRemarks: sr?.rejectionRemarks,
        });

      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);

    } finally {
      setBtnLoader(null)
    }
  };

  const renderSortIcons = (field) => (
    <span className="sort-icons">
      <img
        src={uparrowSort}
        alt="upsort"
        className={
          sortConfig.field === field &&
            sortConfig.direction === "asc"
            ? "sort-arrow active"
            : "sort-arrow"
        }
      />
      <img
        src={downarrowSort}
        alt="downsort"
        className={
          sortConfig.field === field &&
            sortConfig.direction === "desc"
            ? "sort-arrow active"
            : "sort-arrow"
        }
      />
    </span>
  );

  const sortedData = [...filtered].sort((a, b) => {
    if (!sortConfig.field) return 0;

    const { field, direction, type } = sortConfig;

    let valueA = a[field];
    let valueB = b[field];

    if (type === "string") {
      valueA = String(valueA || "").toLowerCase();
      valueB = String(valueB || "").toLowerCase();

      return direction === "asc"
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    }

    if (type === "date") {
      valueA = moment(valueA, "DD-MM-YYYY").valueOf();
      valueB = moment(valueB, "DD-MM-YYYY").valueOf();

      return direction === "asc"
        ? valueA - valueB
        : valueB - valueA;
    }

    return 0;
  });

  useEffect(() => {
  if (selectedSR) {
    reviewSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
}, [selectedSR]);

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleResetFilter = () => {
    setFromDate("");
    setToDate("");
    getSrRequestData("grid", search, "", "");
  };

  const handleApplyFilter = () => {
    setPage(1);
  
    const from = moment(fromDate, "DD-MM-YYYY", true);
    const to = moment(toDate, "DD-MM-YYYY", true);
    const today = moment().startOf("day");
  
    if (!from.isValid() || !to.isValid()) {
      toast.error("Please enter valid dates");
      return;
    }

      if (from.isAfter(today)) {
    toast.error("From Date cannot be a future date");
    return;
  }

  if (to.isAfter(today)) {
    toast.error("To Date cannot be a future date");
    return;
  }
  
    if (to.isBefore(from)) {
      toast.error("To Date cannot be earlier than From Date");
      return;
    }
  
    const diff = to.diff(from, "days");
  
    if (diff > 31) {
      toast.error("Date range should not exceed 1 month");
      return;
    }
  
    getSrRequestData("grid", search, fromDate, toDate);
    setFilterModal(false);
  };

  const showFilterModal = () => {
    setFilterModal(true);
  }

  const handleFilterKeyDown = (e) => {
  if (e.key === "Enter" && isBothDatesSelected) {
    e.preventDefault();
    handleApplyFilter();
  }
};

  const isBothDatesSelected =
  fromDate &&
  toDate &&
  fromDate.split("-").length === 3 &&
  toDate.split("-").length === 3;

  const handleCloseFilter = () => {
    setFromDate("");
    setToDate("");
    setFilterModal(false);
  };


  return (
    <>
      <div className="off-market-main">
        <Header title="Off-Market Trade Date Update" portal={""} />
        <SingleSignOnSideBar />
        <main id="offmarket-main-content">
          <div className="tab-content card-box off-market-tab">
            <div className="ckr-page new-upload">

              <div className="ckr-sticky-heading">
                <p className="ckr-section-title">Checker Queue</p>
              </div>

              <div className="ckr-queue-wrapper">
                <div className="ckr-stats">
                  <div className="ckr-stat-card status-card">
                    <img src={AvgTatIcon} alt="" className="ckr-stat-icon-img" />
                    <div className="ckr-stat-info">
                      <span className="status-title">Average TAT</span>
                      <span className="wrap-card-text">
                        <span className="ckr-stat-value">{cardData?.AvgTAT}</span>
                        <span className="ckr-stat-sublabel">Days to decision</span>
                      
                      </span>
                    </div>
                  </div>
                  <div className="ckr-stat-card status-card">
                    <img src={InQueueIcon} alt="" className="ckr-stat-icon-img" />
                    <div className="ckr-stat-info">
                      <span className="status-title">In Queue</span>
                      <span className="wrap-card-text">
                      <span className="ckr-stat-value ckr-stat-value--queue">{cardData?.PendingCnt}</span>
                        <span className="ckr-stat-sublabel">Pending review</span>
                      </span>
                    </div>
                  </div>
                  <div className="ckr-stat-card status-card">
                    <img src={ApprovedTodayIcon} alt="" className="ckr-stat-icon-img" />
                    <div className="ckr-stat-info">
                      <span className="status-title">Approved</span>
                      <span className="ckr-stat-value ckr-stat-value--approved">{cardData?.ApprovedTodayCnt}</span>
                    </div>
                  </div>
                  <div className="ckr-stat-card status-card">
                    <img src={RejectedTodayIcon} alt="" className="ckr-stat-icon-img" />
                    <div className="ckr-stat-info">
                      <span className="status-title">Rejected</span>
                      <span className="ckr-stat-value ckr-stat-value--rejected">{cardData?.RejectedTodayCnt}</span>
                    </div>
                  </div>
                </div>
              </div>

              {selectedSR?.status === "Pending" && (
                <div className="ckr-reviewing-banner">
                  <span className="banner-text-checkr">
                    <span className="bold-text">Reviewing {selectedSRId.srId}</span> &ndash; Submitted
                    by {selectedSRId.clientName} on {" "}
                    {moment(selectedSRId.submissionDate, "DD-MM-YYYY").format("DD MMM YYYY").toUpperCase()}
                  </span>
                  <span className="records">
                    {selectedSRId.records} CLIENTS
                  </span>
                </div>
              )}

              {selectedSR && (
                <div className="wrap-all-tabs" ref={reviewSectionRef}>
                  <PendingForReview
                    sr={selectedSR}
                    setSelectedSR={setSelectedSR}
                    onSkip={() => setSelectedSRId(null)}
                    refreshSRList={() => getSrRequestData("grid")}
                    refreshCardData={() => getCardSummary()}
                  />
                </div>
              )}

              {selectedSR?.status === "Rejected" &&
                selectedSR?.rejectionRemarks?.trim() && (
                <div className="reject-remark-cont">
                  <div>
                    <img src={editIcon} alt="edit" />
                  </div>
                  <div className="wrap-content">
                    <span className="bold-text ">
                      Remarks
                    </span>
                    <span className="remarks-val">
                      {selectedSR.rejectionRemarks}
                    </span>
                  </div>
                </div>
              )}

              <div className="ckr-section">
                <div className="ckr-section-header">
                  <p className="ckr-section-title">All Service Requests</p>

                  <div className="header-filter">

                    <div className="filter-options offmark-filter">
                      <div className="dropdown-filter">
                        <select
                          size="lg"
                          aria-label="Default select example"
                          value={statusFilter}
                          onChange={(e) => {setPage(1);
                            setStatusFilter(e.target.value)
                          }}
                        >
                          <option value="">All</option>
                          <option value="Approved">Approved</option>
                          <option value="Pending">Pending</option>
                          <option value="Rejected">Rejected</option>
                        </select>
                      </div>
                    </div>

                    <div className="filter-wrapper" onClick={showFilterModal}>
                      <img src={filter} alt="filter" />
                    </div>

                    <div className="ckr-search-box">

                      <i className="fa fa-search" />
                      <input
                        type="text"
                        placeholder="Search by client code/name"
                        value={search}
                        maxLength={50}
                        onChange={(e) =>
                          setSearch(alphaNumericUppercase(e.target.value, 50))
                        }
                        onPaste={alphaNumericUppercasePaste(50)}
                      />
                    </div>
                  </div>
                </div>
                <div className="ckr-table-wrapper scroll-table">
                  {loader ?
                    <div className="loader-alignment">
                      <Loader />
                    </div>
                    :
                    filtered && filtered?.length > 0 ?
                      <>
                        <table className="ckr-table draft-maker">
                          <thead>
                            <tr>
                              <th>Client Name </th>
                              <th className="sortable-header"
                                onClick={() => handleSort("srId", "string")}>
                                Sr Id {renderSortIcons("srId")}
                              </th>
                              <th>Submitted by</th>
                              <th>ISIN</th>
                              <th>No. of Transactions</th>
                              <th className="sortable-header"
                                onClick={() => handleSort("submissionDate", "date")}>
                                Submission Date {renderSortIcons("submissionDate")}
                              </th>
                              <th className="sortable-header"
                                onClick={() => handleSort("status", "string")}>
                                Status {renderSortIcons("status")}
                              </th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortedData.map((sr) => (
                              <tr
                                key={sr.id}
                                className={selectedSR?.id === sr.id ? "ckr-active-row" : ""}
                              >
                                <td>{sr?.clientName ? toTitleCase(sr?.clientName) : "-"}</td>
                                <td>{sr.srId || "-"}</td>
                                <td>{sr.clientCode || "-"}</td>

                                <td>{sr.isin || "-"}</td>
                                <td>{sr.records || "-"}</td>
                                <td>{sr.submissionDate || "-"}</td>
                                <td>
                                  {sr?.status !== "" ?
                                    <span
                                      className={`${sr.status === "Pending" ? "status-pending" :
                                        sr.status === "Approved" ? "status-approved" :
                                          sr.status === "Rejected" ? "status-rejected" : ""
                                        }`}>
                                      {sr?.status}
                                    </span>
                                    : "-"}
                                </td>
                                <td>
                                  <div className="view-btn">
                                    <button
                                      className="submit-btns-view"
                                      onClick={() => handleViewButton(sr)}
                                      disabled={selectedSR?.id === sr.id || btnLoader === sr.id}
                                    >
                                      {btnLoader === sr?.id ?
                                        <SmallLoader />
                                        :
                                        <>
                                          VIEW DETAILS
                                        </>
                                      }
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                      :
                      <div className="step-content report-error-message">
                        {noDataFound()}
                      </div>
                  }
                </div>
              </div>

              {filtered && filtered?.length > 0 && (
                <div className="d-flex align-items-center justify-content-between">

                  {/* Left Side */}
                  <div className="pagination-left d-flex align-items-center">
                    <span className="items-label">Items per page</span>

                    <select
                      value={limit}
                      onChange={(e) => {
                        setLimit(Number(e.target.value));
                        setPage(1);
                      }}
                      className="page-select"

                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>

                    <span className="page-count">
                      {count === 0
                        ? "0-0 items"
                        : `${(page - 1) * limit + 1}-${Math.min(
                          page * limit,
                          count
                        )} of ${count} items`}
                    </span>
                  </div>

                  <div className="pagination-right d-flex align-items-center">

                    <button
                      className="pagination-btn"
                      disabled={page === 1}
                      onClick={() => setPage((prev) => prev - 1)}
                    >
                      &lt;
                    </button>

                    {Array.from(
                      { length: Math.ceil(count / limit) },
                      (_, index) => (
                        <button
                          key={index + 1}
                          className={`pagination-number ${page === index + 1 ? "active-page" : ""
                            }`}
                          onClick={() => setPage(index + 1)}
                        >
                          {index + 1}
                        </button>
                      )
                    )}

                    <button
                      className="pagination-btn"
                      disabled={page === Math.ceil(count / limit)}
                      onClick={() => setPage((prev) => prev + 1)}
                    >
                      &gt;
                    </button>
                  </div>
                </div>
              )}

            </div>
          </div>

        </main>
      </div>
      <Modal
        show={filterModal}
        onHide={() => setFilterModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model offmark-date-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac header-pnl">
              <span className="header-title">Filters</span>
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleCloseFilter}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table"
          onKeyDown={handleFilterKeyDown}>
            <span className="body-title">Custom Date Range</span>

            <div className="date-wrapper">
              <div className="form-group">
                <label htmlFor="" className="form-label">
                  From Date:
                </label>
                <div>
                  <CustomTradeDate
                    idPrefix="fromDate"
                      value={fromDate}
                      onChange={(date) => {
                        setFromDate(date);
                      }}
                      maxDate={toDate || DateReverse}
                    />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="" className="form-label">
                  To Date:
                </label>
                <div>
                  <CustomTradeDate
                  idPrefix="toDate"
                    value={toDate}
                    onChange={(date) => {
                      setToDate(date);
                    }}
                    minDate={fromDate}
                    maxDate={DateReverse}
                  />
                </div>
              </div>
            </div>

            <div className="info-banner">
              <img src={infoIcon} alt="info icon" />
              <span className="banner-text">Please select a date range where difference between From date and To date is less than 1 month</span>
            </div>

            <div className="footer-actions modal-footer">
              <button type="button" className="back-btn" onClick={() => handleResetFilter()} disabled={!isBothDatesSelected}>RESET</button>
              <button type="submit" className="submit-btns" onClick={handleApplyFilter} disabled={!isBothDatesSelected}>
                APPLY
              </button>
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CheckerMain;
